// Version : 0.0.3
// Author : VISHAL BHARATHI
// LastEdit : VISHAL BHARATHI
// Last ADD : CASE CHANGES
// MODFIED DATA : 23-08-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';
import AutoLoanCollectionTypes from './auto-loan-collection.types';
import {
	fetchAutoLoanIndexDetail,
	fetchAutoLoanCollectionDetail,
	autoLoanCollectionUpdate,
	revertAutoLoanMemberSaving,
	autoLoanCollectionRevert,
	autoLoanInterestWaiverUpdateAPI,
	autoLoanCollectionApprovalAPI,
	autoLoanCollectionVehicleSeizedAPI,
	addAutoLoanMemberWalletService,
	fetchAutoLoanRepaymentDetail,
	fetchAutoLoanArrearCollectionsDetail,
	fetchAutoLoanVehicleDetailsAPI,
} from './auto-loan-collection.services';
import {
	fetchAutoLoanIndexSuccess,
	fetchAutoLoanIndexFailure,
	fetchAutoLoanIndexResponseChanged,
	fetchAutoLoanCollectionSuccess,
	fetchAutoLoanCollectionFailure,
	fetchAutoLoanCollectionResponseChanged,
	revertAutoLoanCollectionFailure,
	revertAutoLoanCollectionSuccess,
	revertAutoLoanCollectionResponseChanged,
	updatAutoLoanCollectionResponseChanged,
	updatAutoLoanCollectionFailure,
	updatAutoLoanCollectionSuccess,
	revertAutoLoanMemberWalletSucess,
	revertAutoLoanMemberWalletFailure,
	revertAutoLoanMemberWalletResponseChanged,
	updateAutoLoanInterestWaiverSuccess,
	updateAutoLoanInterestWaiverFailure,
	updateAutoLoanInterestWaiverResponseChanged,
	autoLoanCollectionApprovalFailure,
	autoLoanCollectionApprovalSuccess,
	autoLoanCollectionApprovalResponseChanged,
	autoLoanCollectionVehicleSeizedFailure,
	autoLoanCollectionVehicleSeizedSuccess,
	autoLoanCollectionVehicleSeizedResponseChanged,
	addAutoLoanMemberWalletSuccess,
	addAutoLoanMemberWalletFailure,
	addAutoLoanMemberWalletResponseChanged,
	fetchAutoLoanRepaymentSuccess,
	fetchAutoLoanRepaymentFailure,
	fetchAutoLoanRepaymentResponseChanged,
	fetchAutoLoanArrearCollectionsSuccess,
	fetchAutoLoanArrearCollectionsFailure,
	fetchAutoLoanArrearCollectionsResponseChanged,
	fetchAutoLoanVehicleDetailsSuccess,
	fetchAutoLoanVehicleDetailsFailure,
	fetchAutoLoanVehicleDetailsResponseChanged,
} from './auto-loan-collection.action';
import { encryptData } from '../../../_common/enode-decode';

/** *********************  START AUTO LOAN INDEX LIST ******************** */
export function* fetchAutoLoanIndexList({ payload }: any) {
	try {
		const key = 'FetchAutoLoanIndexListKey';
		const {
			searchMemberValue,
			searchMemberType,
			memberCompanyID,
			userID,
			userRole,
			level,
			databaseName,
			provisionType,
		} = payload;
		const jsonData = {
			searchMemberValue: searchMemberValue,
			searchMemberType: searchMemberType,
			MemberCompanyID: memberCompanyID,
			UserID: userID,
			UserRole: userRole,
			Level: level,
			DatabaseName: databaseName,
			ProvisionType: provisionType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchAutoLoanIndexDetail, encodeData);
		if (responseData.data.statusCode === '100') {
			yield put(fetchAutoLoanIndexFailure(responseData.data));
		} else {
			yield put(fetchAutoLoanIndexSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAutoLoanIndexFailure(error));
	}
}

export function* resetAutoLoanIndexListResponse() {
	yield put(fetchAutoLoanIndexResponseChanged());
}

export function* onAutoLoanIndexList() {
	yield takeLatest(
		AutoLoanCollectionTypes.FETCH_AUTO_LOAN_INDEX_LIST_START,
		fetchAutoLoanIndexList,
	);
}

export function* onAutoLoanIndexListResponseReset() {
	yield takeLatest(
		AutoLoanCollectionTypes.FETCH_AUTO_LOAN_INDEX_LIST_RESPONSE_RESET,
		resetAutoLoanIndexListResponse,
	);
}
/** *********************  END AUTO LOAN INDEX LIST  ******************** */

/** *********************  START AUTO LOAN COLLECTION LIST ******************** */
export function* fetchAutoLoanCollectionList({ payload }: any) {
	try {
		const key = 'getAutoLoanCollectionKey';
		const { companyID, userLevel, databaseName, userID, autoLoanIndexID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			MemberCompanyID: companyID,
			UserID: userID,
			Level: userLevel,
			AutoLoanIndexID: autoLoanIndexID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchAutoLoanCollectionDetail, encodeData);
		if (responseData.data.statusCode === '100') {
			yield put(fetchAutoLoanCollectionFailure(responseData.data));
		} else {
			yield put(fetchAutoLoanCollectionSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAutoLoanCollectionFailure(error));
	}
}

export function* resetAutoLoanCollectionListResponse() {
	yield put(fetchAutoLoanCollectionResponseChanged());
}

export function* onAutoLoanCollectionList() {
	yield takeLatest(
		AutoLoanCollectionTypes.FETCH_AUTO_LOAN_COLLECTION_LIST_START,
		fetchAutoLoanCollectionList,
	);
}

export function* onAutoLoanCollectionListResponseReset() {
	yield takeLatest(
		AutoLoanCollectionTypes.FETCH_AUTO_LOAN_COLLECTION_LIST_RESPONSE_RESET,
		resetAutoLoanCollectionListResponse,
	);
}
/** *********************  END AUTO LOAN INDEX LIST  ******************** */

/** *********************** SATRT UPDATE AUTO LOAN COLLECTION ************************ */
export function* updateAutoLoanCollection({ payload }: any) {
	const key = 'UpdateAutoLoanPaidCollectionKey';
	try {
		const {
			companyID,
			collectionDate,
			databaseName,
			userID,
			userName,
			branchID,
			centerID,
			groupID,
			loanPaidID,
			fiveHundred,
			twoHundred,
			hundred,
			fifty,
			twenty,
			ten,
			five,
			two,
			one,
			totalDenomination,
			isAllCenter,
			isGroup,
			paymentFrom,
			paymentMethod,
			collectionLoanArr,
		} = payload;
		const CollectionLoanArr = JSON.stringify(collectionLoanArr).replace(/"/g, "'");
		const jsonData = {
			CompanyID: companyID,
			CollectionLoanArr,
			CollectionDate: collectionDate,
			DatabaseName: databaseName,
			UserID: userID,
			UserName: userName,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			TwoThousand: 0,
			LoanPaidID: loanPaidID,
			FiveHundred: fiveHundred,
			TwoHundred: twoHundred,
			Hundred: hundred,
			Fifty: fifty,
			Twenty: twenty,
			Ten: ten,
			Five: five,
			Two: two,
			One: one,
			TotalDenomination: totalDenomination,
			IsAllCenter: isAllCenter,
			IsGroup: isGroup,
			collectionPage: paymentFrom,
			paymentMethod: paymentMethod,
		};
		const fetchData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(autoLoanCollectionUpdate, fetchData);
		if (responseData.data.statusCode === '100') {
			yield put(updatAutoLoanCollectionFailure(responseData.data));
		} else {
			yield put(updatAutoLoanCollectionSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updatAutoLoanCollectionFailure(error));
	}
}

export function* updateAutoCollectionResponseReset() {
	yield put(updatAutoLoanCollectionResponseChanged());
}

export function* onUpdateAutoLoanCollection() {
	yield takeLatest(
		AutoLoanCollectionTypes.UPDATE_AUTO_LOAN_COLLECTION_START,
		updateAutoLoanCollection,
	);
}

export function* onUpdateAutoLoanCollectionResponseReset() {
	yield takeLatest(
		AutoLoanCollectionTypes.UPDATE_AUTO_LOAN_COLLECTION_RESPONSE_RESET_START,
		updateAutoCollectionResponseReset,
	);
}
/** *********************** END UPDATE AUTO LOAN COLLECTION ************************ */

/** *********************** REVERT AUTO LOAN COLLECTION START  ************************ */
export function* revertAutoLoanCollection({ payload }: any) {
	const key = 'RevertAutoLoanPaidEntryKey';
	try {
		const { companyID, autoLoanPaidID, arrearCollectionID, databaseName, userID } = payload;
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			DatabaseName: databaseName,
			DueID: autoLoanPaidID,
			ArrearCollectionID: arrearCollectionID,
		};
		const fetchData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(autoLoanCollectionRevert, fetchData);
		if (responseData.data.statusCode === '100') {
			yield put(revertAutoLoanCollectionFailure(responseData.data));
		} else {
			yield put(revertAutoLoanCollectionSuccess(responseData.data));
		}
	} catch (error) {
		yield put(revertAutoLoanCollectionFailure(error));
	}
}

export function* revertAutoCollectionResponseReset() {
	yield put(revertAutoLoanCollectionResponseChanged());
}

export function* onRevertAutoLoanCollection() {
	yield takeLatest(
		AutoLoanCollectionTypes.REVERT_AUTO_LOAN_COLLECTION_START,
		revertAutoLoanCollection,
	);
}

export function* onRevertAutoLoanCollectionResponseReset() {
	yield takeLatest(
		AutoLoanCollectionTypes.REVERT_AUTO_LOAN_COLLECTION_RESPONSE_RESET_START,
		revertAutoCollectionResponseReset,
	);
}
/** *********************** END REVERT AUTO LOAN COLLECTION ************************ */

/** *********************** AUTO LOAN MEMBER DELETE SAVING START  ************************ */
export function* autoLoanMemberDeleteSavingSaga({ payload }: any) {
	const key = 'RevertAutoLoanMemberWalletDataKey';
	try {
		const { companyID, userAccessBranchID, databaseName, userID, userName, savingAmountID } =
			payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			SavingAmountID: savingAmountID,
			UserID: userID,
			prevSavingAmountID: savingAmountID,
			UserName: userName,
			UserAccessBranchID: userAccessBranchID,
		};
		const fetchData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(revertAutoLoanMemberSaving, fetchData);
		if (responseData.data.statusCode === '100') {
			yield put(revertAutoLoanMemberWalletFailure(responseData.data));
		} else {
			yield put(revertAutoLoanMemberWalletSucess(responseData.data));
		}
	} catch (error) {
		yield put(revertAutoLoanMemberWalletFailure(error));
	}
}

export function* autoLoanMemberDeleteSavingResponseReset() {
	yield put(revertAutoLoanMemberWalletResponseChanged());
}

export function* onAutoLoanMemberDeleteSaving() {
	yield takeLatest(
		AutoLoanCollectionTypes.REVERT_AUTO_LOAN_MEMBER_WALLET_START,
		autoLoanMemberDeleteSavingSaga,
	);
}

export function* onAutoLoanMemberDeleteSavingResponseReset() {
	yield takeLatest(
		AutoLoanCollectionTypes.REVERT_AUTO_LOAN_MEMBER_WALLET_RESPONSE_RESET_START,
		autoLoanMemberDeleteSavingResponseReset,
	);
}
/** *********************** END AUTO LOAN MEMBER DELETE SAVING ************************ */

/** ********************* UPDATE AUTO LOAN INTEREST WAIVER LIST START ******************** */
export function* updateAutoLoanInterestWaiverList({ payload }: any) {
	try {
		const key = 'UpdateAutoLoanInterestWaiverDataKey';
		const {
			databaseName,
			companyID,
			userID,
			autoLoanID,
			memberID,
			interestWaiverAmount,
			interestWaiverReason,
			waiverDueLoans,
		} = payload;

		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			AutoLoanID: autoLoanID,
			MemberID: memberID,
			InterestWaiverAmount: interestWaiverAmount,
			InterestWaiverReason: interestWaiverReason,
			WaiverDueLoans: waiverDueLoans,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(autoLoanInterestWaiverUpdateAPI, encodeData);
		if (responseData.data.statusCode === '100') {
			yield put(updateAutoLoanInterestWaiverFailure(responseData.data));
		} else {
			yield put(updateAutoLoanInterestWaiverSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateAutoLoanInterestWaiverFailure(error));
	}
}

export function* resetAutoLoanInterestWaiverUpdateResponse() {
	yield put(updateAutoLoanInterestWaiverResponseChanged());
}

export function* onAutoLoanInterestWaiverUpdate() {
	yield takeLatest(
		AutoLoanCollectionTypes.UPDATE_AUTO_LOAN_INTEREST_WAIVER_START,
		updateAutoLoanInterestWaiverList,
	);
}

export function* onAutoLoanInterestWaiverUpdateResponseReset() {
	yield takeLatest(
		AutoLoanCollectionTypes.UPDATE_AUTO_LOAN_INTEREST_WAIVER_RESPONSE_RESET,
		resetAutoLoanInterestWaiverUpdateResponse,
	);
}
/** ********************* UPDATE AUTO LOAN INTEREST WAIVER LIST END ******************** */

/** *********************  MEMBER LOAN COLLECTION APPROVAL START ******************** */
export function* autoLoanCollectionApproval({ payload }: any) {
	try {
		const key = 'ApproveAutoLoanCollectionKey';
		const { databaseName, companyID, autoLoanPaidID } = payload;

		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			LoanPaidID: autoLoanPaidID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(autoLoanCollectionApprovalAPI, encodeData);
		if (responseData.data.statusCode === '100') {
			yield put(autoLoanCollectionApprovalFailure(responseData.data));
		} else {
			yield put(autoLoanCollectionApprovalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(autoLoanCollectionApprovalFailure(error));
	}
}

export function* getAutoLoanCollectionApproval() {
	yield put(autoLoanCollectionApprovalResponseChanged());
}

export function* onAutoLoanCollectionApproval() {
	yield takeLatest(
		AutoLoanCollectionTypes.AUTO_LOAN_COLLECTION_APPROVAL_START,
		autoLoanCollectionApproval,
	);
}

export function* onAutoLoanCollectionApprovalResponseReset() {
	yield takeLatest(
		AutoLoanCollectionTypes.AUTO_LOAN_COLLECTION_APPROVAL_RESPONSE_RESET,
		getAutoLoanCollectionApproval,
	);
}
/** *********************  MEMBER LOAN COLLECTION APPROVAL END ******************** */

/** *********************  AUTO LOAN COLLECTION VEHICLE SEIZED START ******************** */
export function* autoLoanCollectionVehicleSeized({ payload }: any) {
	try {
		const key = 'AutoLoanCollectionVehicleSeizedKey';
		const {
			databaseName,
			companyID,
			autoLoanIndexID,
			isSeized,
			seizedReason,
			seizedDate,
			seizedPlace,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			LoanIndexID: autoLoanIndexID,
			IsSeized: isSeized,
			SeizedReason: seizedReason,
			SeizedDate: seizedDate,
			SeizedPlace: seizedPlace,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(autoLoanCollectionVehicleSeizedAPI, encodeData);
		if (responseData.data.statusCode === '100') {
			yield put(autoLoanCollectionVehicleSeizedFailure(responseData.data));
		} else {
			yield put(autoLoanCollectionVehicleSeizedSuccess(responseData.data));
		}
	} catch (error) {
		yield put(autoLoanCollectionVehicleSeizedFailure(error));
	}
}

export function* getAutoLoanCollectionVehicleSeized() {
	yield put(autoLoanCollectionVehicleSeizedResponseChanged());
}

export function* onAutoLoanCollectionVehicleSeized() {
	yield takeLatest(
		AutoLoanCollectionTypes.AUTO_LOAN_COLLECTION_VEHICLE_SEIZED_START,
		autoLoanCollectionVehicleSeized,
	);
}

export function* onAutoLoanCollectionVehicleSeizedResponseReset() {
	yield takeLatest(
		AutoLoanCollectionTypes.AUTO_LOAN_COLLECTION_VEHICLE_SEIZED_RESPONSE_RESET,
		getAutoLoanCollectionVehicleSeized,
	);
}
/** *********************  AUTO LOAN COLLECTION VEHICLE SEIZED END ******************** */

/** *********************** ADD AUTO LOAN MEMBER WALLET START ************************ */
export function* addAutoLoanMemberWalletSaga({ payload }: any) {
	const key = 'AddAutoLoanMemberWalletTokenKey';
	try {
		const {
			databaseName,
			companyID,
			userID,
			loanIndexGroupMemberID,
			memberID,
			walletAmount,
			paidDate,
			loanpaidID,
		} = payload;

		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
			MemberID: memberID,
			WalletAmount: walletAmount,
			PaidDate: paidDate,
			LoanPaidID: loanpaidID,
		};
		const fetchData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(addAutoLoanMemberWalletService, fetchData);
		if (responseData.data.statusCode === '100') {
			yield put(addAutoLoanMemberWalletFailure(responseData.data));
		} else {
			yield put(addAutoLoanMemberWalletSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addAutoLoanMemberWalletFailure(error));
	}
}

export function* addAutoLoanMemberWalletResponseResetSaga() {
	yield put(addAutoLoanMemberWalletResponseChanged());
}

export function* onAddAutoLoanMemberWallet() {
	yield takeLatest(
		AutoLoanCollectionTypes.ADD_AUTO_LOAN_MEMBER_WALLET_START,
		addAutoLoanMemberWalletSaga,
	);
}

export function* onAddAutoLoanMemberWalletResponseReset() {
	yield takeLatest(
		AutoLoanCollectionTypes.ADD_AUTO_LOAN_MEMBER_WALLET_RESPONSE_RESET_START,
		addAutoLoanMemberWalletResponseResetSaga,
	);
}
/** *********************** END ADD AUTO LOAN MEMBER WALLET ************************ */

/** *********************** END ADD AUTO LOAN MEMBER WALLET ************************ */

/** *********************  FETCH AUTO LOAN REPAYMENT LIST START ******************** */
export function* fetchAutoLoanRepaymentList({ payload }: any) {
	try {
		const key = 'FetchAutoLoanRepaymentKey';
		const { databaseName, companyID, autoLoanIndexID, memberID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			AutoLoanIndexID: autoLoanIndexID,
			MemberID: memberID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchAutoLoanRepaymentDetail, encodeData);
		if (responseData.data.statusCode === '100') {
			yield put(fetchAutoLoanRepaymentFailure(responseData.data));
		} else {
			yield put(fetchAutoLoanRepaymentSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAutoLoanRepaymentFailure(error));
	}
}

export function* resetAutoLoanRepaymentFetchResponse() {
	yield put(fetchAutoLoanRepaymentResponseChanged());
}

export function* onAutoLoanRepaymentDetailsFetch() {
	yield takeLatest(
		AutoLoanCollectionTypes.FETCH_AUTO_LOAN_REPAYMENT_START,
		fetchAutoLoanRepaymentList,
	);
}

export function* onAutoLoanRepaymentDetailsFetchResponseReset() {
	yield takeLatest(
		AutoLoanCollectionTypes.FETCH_AUTO_LOAN_REPAYMENT_RESPONSE_RESET,
		resetAutoLoanRepaymentFetchResponse,
	);
}
/** *********************  FETCH AUTO LOAN REPAYMENT LIST END ******************** */

/** *********************  FETCH AUTO LOAN ARREAR COLLECTIONS LIST START ******************** */
export function* fetchAutoLoanArrearCollectionsList({ payload }: any) {
	try {
		const key = 'FetchAutoLoanArrearCollectionsKey';
		const { databaseName, companyID, branchID, groupID, loanPaidID, memberID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			BranchID: branchID,
			GroupID: groupID,
			LoanPaidID: loanPaidID,
			MemberID: memberID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchAutoLoanArrearCollectionsDetail, encodeData);
		if (responseData.data.statusCode === '100') {
			yield put(fetchAutoLoanArrearCollectionsFailure(responseData.data));
		} else {
			yield put(fetchAutoLoanArrearCollectionsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAutoLoanArrearCollectionsFailure(error));
	}
}

export function* resetAutoLoanArrearCollectionsFetchResponse() {
	yield put(fetchAutoLoanArrearCollectionsResponseChanged());
}

export function* onAutoLoanArrearCollectionsFetch() {
	yield takeLatest(
		AutoLoanCollectionTypes.FETCH_AUTO_LOAN_ARREAR_COLLECTIONS_START,
		fetchAutoLoanArrearCollectionsList,
	);
}

export function* onAutoLoanArrearCollectionsFetchResponseReset() {
	yield takeLatest(
		AutoLoanCollectionTypes.FETCH_AUTO_LOAN_ARREAR_COLLECTIONS_RESPONSE_RESET,
		resetAutoLoanArrearCollectionsFetchResponse,
	);
}
/** *********************  FETCH AUTO LOAN ARREAR COLLECTIONS LIST END ******************** */

/** *********************  FETCH AUTO LOAN VEHICLE DETAILS START ******************** */
export function* fetchAutoLoanVehicleDetails({ payload }: any) {
	try {
		const key = 'FetchAutoLoanVehicleKey';
		const { databaseName, companyID, memberID, autoLoanIndexID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			MemberID: memberID,
			AutoLoanID: autoLoanIndexID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchAutoLoanVehicleDetailsAPI, encodeData);
		if (responseData.data.statusCode === '100') {
			yield put(fetchAutoLoanVehicleDetailsFailure(responseData.data));
		} else {
			yield put(fetchAutoLoanVehicleDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAutoLoanVehicleDetailsFailure(error));
	}
}

export function* resetAutoLoanVehicleDetailsFetchResponse() {
	yield put(fetchAutoLoanVehicleDetailsResponseChanged());
}

export function* onAutoLoanVehicleDetailsFetch() {
	yield takeLatest(
		AutoLoanCollectionTypes.FETCH_AUTO_LOAN_VEHICLE_DETAILS_START,
		fetchAutoLoanVehicleDetails,
	);
}

export function* onAutoLoanVehicleDetailsFetchResponseReset() {
	yield takeLatest(
		AutoLoanCollectionTypes.FETCH_AUTO_LOAN_VEHICLE_DETAILS_RESPONSE_RESET,
		resetAutoLoanVehicleDetailsFetchResponse,
	);
}
/** *********************  FETCH AUTO LOAN VEHICLE DETAILS END ******************** */

export function* autoLoanCollectionSaga() {
	yield all([
		call(onAutoLoanIndexList),
		call(onAutoLoanIndexListResponseReset),
		call(onAutoLoanCollectionList),
		call(onAutoLoanCollectionListResponseReset),
		call(onUpdateAutoLoanCollection),
		call(onUpdateAutoLoanCollectionResponseReset),
		call(onRevertAutoLoanCollection),
		call(onRevertAutoLoanCollectionResponseReset),
		call(onAutoLoanMemberDeleteSaving),
		call(onAutoLoanMemberDeleteSavingResponseReset),
		call(onAutoLoanInterestWaiverUpdate),
		call(onAutoLoanInterestWaiverUpdateResponseReset),
		call(onAutoLoanCollectionApproval),
		call(onAutoLoanCollectionApprovalResponseReset),
		call(onAutoLoanCollectionVehicleSeized),
		call(onAutoLoanCollectionVehicleSeizedResponseReset),
		call(onAddAutoLoanMemberWallet),
		call(onAddAutoLoanMemberWalletResponseReset),
		call(onAutoLoanRepaymentDetailsFetch),
		call(onAutoLoanRepaymentDetailsFetchResponseReset),
		call(onAutoLoanArrearCollectionsFetch),
		call(onAutoLoanArrearCollectionsFetchResponseReset),
		call(onAutoLoanVehicleDetailsFetch),
		call(onAutoLoanVehicleDetailsFetchResponseReset),
	]);
}
